<div class="sdesk-modal open">
  <div class="sdesk-modal-content" [ngClass]="modalSize" *ngIf="modalSize">
    <ng-content></ng-content>
  </div>
</div>
